// extracted by mini-css-extract-plugin
export var container = "_sr-0";
export var dotAnimation = "_sr-2";
export var dotsLoading = "_sr-1";